import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=42edbda9&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"
import style0 from "./login-page.vue?vue&type=style&index=0&id=42edbda9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42edbda9",
  null
  
)

export default component.exports